import PropTypes from 'prop-types';

import styles from './styles.module.css';

const ReferenceItems = ({ items, stacked, separated }) => {
    if (!items || !items.length) return null;

    if (stacked) {
        return (
            <div className={styles.stacked}>
                {items.map((item) => (
                    <div key={item.value} className={styles.item}>
                        <div className={styles.color} style={{ background: `#${item.color}` }} />
                        <div className={styles.value}>{item.value}</div>
                    </div>
                ))}
            </div>
        );
    }

    if (separated) {
        return (
            <div className={styles.separated}>
                {items.map((item) => (
                    <div key={item.value} className={styles.item}>
                        <div className={styles.color} style={{ background: `#${item.color}` }} />
                        <div className={styles.value}>{item.value}</div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={styles.inline}>
            {items.map((item) => (
                <div key={item.value} className={styles.item} style={{ background: `#${item.color}` }}>
                    {item.value}
                </div>
            ))}
        </div>
    );
};

ReferenceItems.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            color: PropTypes.string.isRequired,
        })
    ),
};

export default ReferenceItems;
